module.exports = __webpack_public_path__ + "img/Trace-la-route.cca30a17.jpg";